"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newUneditableShapePinComponent = void 0;
const geometry_1 = require("../geometry");
const order_1 = require("../order");
const random_id_1 = require("../random-id");
/**
 * Creates an UneditableShape Pin Component. An UneditableShape Pin Component, follows the same structure as a Shape Pin Component,
 * but it is not editable by the user. It's use is purely for importing PPTX files into the editor.
 */
function newUneditableShapePinComponent({ position = (0, geometry_1.newVector)(50, 50), size = (0, geometry_1.newSize)(250, 250), rotation = 0, fillColor, order = order_1.defaultOrder, shapeType, strokeColor, strokeThickness, }) {
    return {
        type: 'UNEDITABLE_SHAPE',
        id: (0, random_id_1.randomClientId)(),
        settings: {
            fillColor,
            shapeType,
            strokeColor,
            strokeThickness,
        },
        layout: (0, geometry_1.newBox)(position, size, rotation),
        order,
    };
}
exports.newUneditableShapePinComponent = newUneditableShapePinComponent;
//# sourceMappingURL=uneditable-shape-pin-component.js.map